(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class LmLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lm-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        tooltip.classList.remove('show')
        tooltip.classList.add('hiding')
        setTimeout(() => {
          tooltip.classList.remove('hiding')
        }, 200);
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', LmLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-anime-accordion"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pk-anime-accordion')){
customElements.define('pk-anime-accordion',class extends HTMLElement{
connectedCallback(){
this.controller=new AbortController();const signal=this.controller.signal;
this.panels=[...this.querySelectorAll('.pa-panel')];
this.index=Math.max(0,Math.min(this.panels.length-1,Number(this.dataset.initial)-1));
this.visible=false;

this.panels.forEach((panel,i)=>{
const button=panel.querySelector('.pa-open');
button.addEventListener('click',()=>this.activate(i),{signal});
panel.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'&&matchMedia('(min-width:750px) and (hover:hover)').matches&&!this.querySelector(':focus-visible'))this.activate(i);},{signal});
button.addEventListener('keydown',e=>{let next=i;if(['ArrowRight','ArrowDown'].includes(e.key))next=(i+1)%this.panels.length;else if(['ArrowLeft','ArrowUp'].includes(e.key))next=(i-1+this.panels.length)%this.panels.length;else if(e.key==='Home')next=0;else if(e.key==='End')next=this.panels.length-1;else return;e.preventDefault();this.activate(next);this.panels[next].querySelector('.pa-open').focus();},{signal});
const video=panel.querySelector('video');if(video)video.addEventListener('error',()=>{video.style.visibility='hidden';},{signal});
});
this.addEventListener('shopify:block:select',e=>{const i=this.panels.findIndex(p=>p.dataset.block===e.detail.blockId);if(i>=0)this.activate(i);},{signal});
document.addEventListener('visibilitychange',()=>this.playMedia(),{signal});
this.observer=new IntersectionObserver(es=>{this.visible=es[0].isIntersecting;this.playMedia();},{threshold:.05});this.observer.observe(this);
this.activate(this.index);
}
activate(i){this.index=i;this.panels.forEach((p,n)=>{const active=n===i;p.classList.toggle('is-active',active);p.querySelector('.pa-open').setAttribute('aria-expanded',String(active));p.querySelector('.pa-content').inert=!active;});this.playMedia();}
playMedia(){this.panels.forEach((p,n)=>{const v=p.querySelector('video');if(!v)return;if(n===this.index&&this.visible&&!document.hidden){v.muted=true;v.play().catch(()=>{});}else v.pause();});}
disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();this.panels?.forEach(p=>p.querySelector('video')?.pause());}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-collection-gallery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pk-collection-gallery')){
 customElements.define('pk-collection-gallery',class extends HTMLElement{
  connectedCallback(){
   this.abort=new AbortController();const signal=this.abort.signal;
   this.cards=[...this.querySelectorAll('.pk-gallery-card')];this.stage=this.querySelector('.pk-gallery-stage');
   if(!this.cards.length)return;
   this.index=Math.min(this.cards.length-1,Math.max(0,Number(this.dataset.initial)-1));
   this.classList.add('pk-ready');
   this.querySelectorAll('[data-step]').forEach(b=>b.addEventListener('click',()=>this.go(this.index+Number(b.dataset.step)),{signal}));
   this.querySelectorAll('[data-index]').forEach(b=>b.addEventListener('click',()=>this.go(Number(b.dataset.index)),{signal}));
   this.stage.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.go(this.index+(e.key==='ArrowLeft'?-1:1));}},{signal});
   this.cards.forEach((c,i)=>c.addEventListener('click',e=>{if(this.swiped){e.preventDefault();return;}if(i!==this.index){e.preventDefault();this.go(i);}},{signal}));
   this.stage.addEventListener('pointerdown',e=>{this.start={x:e.clientX,y:e.clientY};this.swiped=false;},{signal});
   this.stage.addEventListener('pointerup',e=>{if(!this.start)return;const dx=e.clientX-this.start.x,dy=e.clientY-this.start.y;this.start=null;if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)){this.swiped=true;this.go(this.index+(dx<0?1:-1));}},{signal});
   this.stage.addEventListener('pointercancel',()=>{this.start=null;},{signal});
   this.stage.addEventListener('dragstart',e=>e.preventDefault(),{signal});
   this.addEventListener('shopify:block:select',e=>{const i=this.cards.findIndex(c=>c.dataset.block===e.detail.blockId);if(i>=0)this.go(i);},{signal});
   this.resize=new ResizeObserver(()=>this.paint());this.resize.observe(this.stage);this.cards.forEach(c=>this.resize.observe(c));
   this.paint();
  }
  go(i){this.index=(i+this.cards.length)%this.cards.length;this.paint();const s=this.querySelector('.pk-gallery-status');if(s)s.textContent=(this.index+1)+' / '+this.cards.length+' · '+this.cards[this.index].querySelector('h3').textContent;}
  paint(){
   const n=this.cards.length,mobile=window.matchMedia('(max-width:749px)').matches;
   const spread=mobile?.77:Number(this.dataset.spread)/100;
   if(!mobile&&this.dataset.fitWidth==='true'){
    const factor=n>=5?4*spread+.61:n>=3?2*spread+.79:n===2?2*spread+1:1;
    this.style.setProperty('--pk-auto-card',Math.max(180,(this.stage.clientWidth-96)/factor)+'px');
   }else this.style.removeProperty('--pk-auto-card');
   const w=this.cards[0].offsetWidth;
   let height=0;
   this.cards.forEach((c,i)=>{
    let d=(i-this.index+n)%n;if(d>n/2)d-=n;
    const a=Math.abs(d),scale=a===0?1:a===1?.79:.61;
    c._scale=scale;height=Math.max(height,c.offsetHeight);
    c.style.transform='translate(calc(-50% + '+(d*w*spread)+'px), -50%) scale('+scale+')';
    c.style.zIndex=String(10-a);c.style.opacity=a>2?'0':'1';c.style.visibility=a>2?'hidden':'visible';c.style.filter=a===0?'none':'brightness(.7)';
    c.style.pointerEvents=a>2?'none':'auto';
    const link=c.querySelector('a');link.tabIndex=i===this.index&&link.hasAttribute('href')?0:-1;
    c.setAttribute('aria-hidden',i===this.index?'false':'true');
   });
   this.stage.style.height=(height+24)+'px';
   this.querySelectorAll('[data-index]').forEach((b,i)=>b.setAttribute('aria-current',i===this.index?'true':'false'));
  }
  disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();}
 });
}

  } catch(e) { console.error(e); }
})();
})();
